import React, {useState} from 'react';
import {Bars3Icon, BellIcon} from '@heroicons/react/24/outline';



const AdminHeader = ({sidebarOpen, setSidebarOpen}) => {
    const [profileOpen, setProfileOpen] = useState(false);

    // Simuler des informations d'administrateur (À remplacer par de vraies données d'authentification)
    const admin = {
        name: 'Admin',
        email: 'admin@resolvia.io',
        avatar: '/api/placeholder/40/40'
    };

    return (
        <header className="flex items-center justify-between px-6 py-4 bg-white border-b-2 border-gray-200">
            <div className="flex items-center">
                <button
                    onClick={() => setSidebarOpen(true)}
                    className="text-gray-500 focus:outline-none lg:hidden"
                >
                    <Bars3Icon className="w-6 h-6"/>
                </button>
                <div className="ml-4 lg:ml-0">
                    <h2 className="text-xl font-semibold text-gray-700">Assistance Expertise Bâtiment -
                        Administration</h2>
                </div>
            </div>

            <div className="flex items-center">
                <div className="flex items-center">
                    <div className="relative">
                        <button
                            onClick={() => setProfileOpen(!profileOpen)}
                            className="flex items-center text-gray-500 focus:outline-none"
                        >
                            <img
                                className="object-cover w-10 h-10 rounded-full"
                                src={admin.avatar}
                                alt="Avatar"
                            />
                            <span className="mx-2 text-sm font-medium">{admin.name}</span>
                        </button>

                        {profileOpen && (
                            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg py-2 shadow-xl z-20">
                                <div className="px-4 py-2 text-sm text-gray-700 border-b">
                                    <div className="font-semibold">{admin.name}</div>
                                    <div className="font-normal">{admin.email}</div>
                                </div>
                                <a href="#"
                                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Profil</a>
                                <a href="#"
                                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Paramètres</a>
                                <a href="#"
                                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Déconnexion</a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default AdminHeader;